import styled from 'styled-components';

export const StyledFinancialData = styled.div`
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 20px;
    width: 100%;
    margin-top: 19px;
    padding: 24px 34px;
    padding-inline-end: 41px;

    .financial-data-wrapper {
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(3, 1fr);
        row-gap: 20px;

        .financial-data-title {
            font-weight: 700;
            font-size: 16px;
            color: #373647;
            opacity: 0.7;
        }

        .payment-request {
            .payments {
                display: flex;
                flex-direction: column;
                gap: 15px;
                margin-top: 25px;
                padding-inline-end: 40px;
                .payment-data {
                    color: rgba(55, 54, 71, 0.7);
                    font-size: 16px;
                    display: flex;
                    justify-content: space-between;

                    .messenger {
                        flex-basis: 50%;
                    }

                    .number {
                        font-weight: 700;
                        flex-basis: 20%;
                    }
                }
            }
        }

        .line-graph {
            grid-column-start: 1;
            grid-column-end: 3;
            position: relative;

            .buttons {
                display: flex;
                gap: 11px;
                position: absolute;
                top: -30px;

                .app-btn {
                    width: 90px;
                    height: 30px;
                    min-width: unset;
                    font-size: 12px;
                }

                .app-btn.not-active {
                    background: #F4F2FE;
                    color: #373647;
                    border: none;
                }
            }
        }

        .pie-chart {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-inline-end: 40px;

            .canvas-pie {
                width: 150px;
                margin-top: 25px;
                border-radius: 50%;
                padding: 10px;
                background: linear-gradient(180deg, #E8F3FF 0%, #FFFFFF 100%);
                box-shadow: -5.9072px -5.9072px 12.6583px rgba(255, 255, 255, 0.9), 5.9072px 4.21943px 29.536px #D9E6F3;
            }
        }

        .incomes-expenses {
            font-weight: 700;
            font-size: 24px;
            color: rgba(55, 54, 71, 0.7);
            margin-inline-start: 70px;

            .currency-value-amount {
                margin: 0;
            }

            .round-progressbar-container {
                width: 42px;
                margin-bottom: 5px;
                position: relative;

                .arrow {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                .arrow.transform {
                    transform: translate(-50%, -50%) rotate(180deg);
                }
            }

            .progress-bar {
                height: 6px;
                width: 100%;
                background: #F4F2FE;
                border-radius: 5px; 
                margin-top: 8px;
                position: relative;

                .percentage {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    top: 0;
                }
                
                .percentage.incomes {
                    width: ${({ income }) => `${income}%`};
                    background: linear-gradient(63.88deg, #6A92FF 7.89%, #8764FF 72.92%);
                }

                .percentage.expenses {
                    width: ${({ expense }) => `${expense}%`};
                    background: linear-gradient(270.3deg, #E632BE 2.83%, #F44197 99.74%);
                }
            }

        }
    }
`